import { Accordion, Nav } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useUserPermissions } from "../../../../utils/auth";
import { PERMISSIONS } from "../../../../constants/permissions";
import { useNavigationGuard } from "../../../../contexts/NavigationGuardContext";

export default function Menu() {
    const { t } = useTranslation(['menu', 'genericDic']);
    const permissions = useUserPermissions();
    const { navigateWithGuard } = useNavigationGuard();

    return (
        <div className="sidebar p-0 vh-100 bg-verd">
            <Accordion defaultActiveKey="0">
                {permissions.length > 0 && (permissions.includes(PERMISSIONS.CLIENT_MANAGEMENT.VIEW) || permissions.includes(PERMISSIONS.USERS_CLIENT.VIEW) || permissions.includes(PERMISSIONS.ORGANIZATIONAL_STRUCTURE.VIEW) ) && (
                    <Accordion.Item eventKey="0">
                        <Accordion.Header>{t("menu:admin.accordeonClientTitle")}</Accordion.Header>
                        <Accordion.Body>
                            <Nav className="flex-column">
                                {permissions.length > 0 && permissions.includes(PERMISSIONS.CLIENT_MANAGEMENT.VIEW) && (

                                    <Nav.Link onClick={() => navigateWithGuard("/admin/client")} >
                                        {t("menu:admin.accordeonClientAction1")}
                                    </Nav.Link>

                                )}
                            </Nav>
                            {permissions.length > 0 && permissions.includes(PERMISSIONS.USERS_CLIENT.VIEW) && (
                                <Nav className="flex-column">
                                    <Nav.Link onClick={() => navigateWithGuard("/admin/users")} >
                                        {t("menu:admin.accordeonClientAction2")}
                                    </Nav.Link>
                                </Nav>
                            )}
                            {permissions.length > 0 && permissions.includes(PERMISSIONS.ROLES.VIEW) && (
                                <Nav className="flex-column">
                                    <Nav.Link onClick={() => navigateWithGuard("/admin/roles")}>
                                        {t("menu:admin.accordeonClientAction4")}
                                    </Nav.Link>
                                </Nav>
                            )}
                            {permissions.length > 0 && permissions.includes(PERMISSIONS.ORGANIZATIONAL_STRUCTURE.VIEW) && (
                                <Nav className="flex-column">
                                    <Nav.Link onClick={() => navigateWithGuard("/admin/organizationalStructures")}>
                                        {t("menu:admin.accordeonClientAction3")}
                                    </Nav.Link>
                                </Nav>
                            )}
                        </Accordion.Body>
                    </Accordion.Item>
                )}
                {permissions.length > 0 && (permissions.includes(PERMISSIONS.SURVEY_UPLOAD.VIEW) || permissions.includes(PERMISSIONS.TEMPLATES.VIEW)  ) && (
                <Accordion.Item eventKey="1">
                    <Accordion.Header>{t("menu:admin.accordeonPollTitle")}</Accordion.Header>
                    <Accordion.Body>
                        {permissions.length > 0 && permissions.includes(PERMISSIONS.TEMPLATES.VIEW) && (
                            <Nav className="flex-column">
                                <Nav.Link onClick={() => navigateWithGuard("/admin/template")} >
                                    {t("menu:admin.accordeonPollAction2")}
                                </Nav.Link>
                            </Nav>
                        )}
                        {permissions.length > 0 && permissions.includes(PERMISSIONS.EXTRA_FIELDS.VIEW) && (
                            <Nav className="flex-column">
                                <Nav.Link onClick={() => navigateWithGuard("/admin/extraFields")}  >
                                    {t("menu:admin.extraFields")}
                                </Nav.Link>
                            </Nav>
                        )}
                    </Accordion.Body>
                </Accordion.Item>
                )}
                {permissions.length > 0 && (permissions.includes(PERMISSIONS.CAMPAIGNS.VIEW) || permissions.includes(PERMISSIONS.SURVEYS.VIEW) || permissions.includes(PERMISSIONS.PARTICIPANTS.VIEW) ) && (
                <Accordion.Item eventKey="2">
                    <Accordion.Header>{t("menu:admin.accordeonCampaignTitle")}</Accordion.Header>
                    <Accordion.Body>
                        <Nav className="flex-column">
                            {permissions.length > 0 && permissions.includes(PERMISSIONS.CAMPAIGNS.VIEW) && (
                                    <Nav.Link onClick={() => navigateWithGuard("/admin/campaign")}>
                                    {t("menu:admin.accordeonCampaignAction1")}
                                </Nav.Link>
                            )}
                        </Nav>
                        <Nav className="flex-column">
                            {permissions.length > 0 && permissions.includes(PERMISSIONS.SURVEYS.VIEW) && (
                                <Nav.Link onClick={() => navigateWithGuard("/admin/surveyList")}>
                                    {t("menu:admin.accordeonCampaignAction2")}
                                </Nav.Link>
                            )}
                        </Nav>
                        <Nav className="flex-column">
                            {permissions.length > 0 && permissions.includes(PERMISSIONS.SURVEYS.VIEW) && (
                                <Nav.Link onClick={() => navigateWithGuard("/admin")}>
                                    {t("menu:admin.accordeonCampaignAction3")}
                                </Nav.Link>
                            )}
                        </Nav>
                        <Nav className="flex-column">
                            {permissions.length > 0 && permissions.includes(PERMISSIONS.PARTICIPANTS.VIEW) && (
                                <Nav.Link onClick={() => navigateWithGuard("/admin/participants")}>
                                    {t("menu:admin.accordeonCampaignAction4")}
                                </Nav.Link>
                            )}
                        </Nav>
                    </Accordion.Body>
                </Accordion.Item>
                )}
                {permissions.length > 0 && (permissions.includes(PERMISSIONS.SENTIMENT_PARAMETERS.VIEW) || permissions.includes(PERMISSIONS.ALERT_PARAMETERS.VIEW) || permissions.includes(PERMISSIONS.GENERAL_PARAMETERS.VIEW)) && (
                    <Accordion.Item eventKey="3">
                        <Accordion.Header>{t("menu:admin.accordeonCriteriaTitle")}</Accordion.Header>
                        <Accordion.Body>
                            <Nav className="flex-column">
                                {permissions.length > 0 && permissions.includes(PERMISSIONS.SENTIMENT_PARAMETERS.VIEW) && (
                                     <Nav.Link onClick={() => navigateWithGuard("/admin/sentiment-analysis")}>
                                        {t("menu:admin.accordeonCriteriaAction1")}
                                    </Nav.Link>
                                )}
                            </Nav>
                            <Nav className="flex-column">
                                {permissions.length > 0 && permissions.includes(PERMISSIONS.ALERT_PARAMETERS.VIEW) && (
                                    <Nav.Link onClick={() => navigateWithGuard("/admin/alertValues")}>
                                        {t("menu:admin.accordeonCriteriaAction2")}
                                    </Nav.Link>
                                )}
                            </Nav>
                            <Nav className="flex-column">
                                {permissions.length > 0 && permissions.includes(PERMISSIONS.GENERAL_PARAMETERS.VIEW) && (
                                    <Nav.Link onClick={() => navigateWithGuard("/admin/generic-params")}>
                                        {t("menu:admin.accordeonCriteriaAction3")}
                                    </Nav.Link>
                                )}
                            </Nav>
                            <Nav className="flex-column">
                                {permissions.length > 0 && permissions.includes(PERMISSIONS.TOPIC_MANAGEMENT.VIEW) && (
                                    <Nav.Link onClick={() => navigateWithGuard("/admin/topics")}>
                                        {t("menu:admin.topicsManagement")}
                                    </Nav.Link>
                                )}
                            </Nav>
                            <Nav className="flex-column">
                                {permissions.length > 0 && permissions.includes(PERMISSIONS.SECURITY_IP.VIEW) && (
                                    <Nav.Link onClick={() => navigateWithGuard("/admin/ips")}>
                                        {t("menu:admin.accesIPManagement")}
                                    </Nav.Link>
                                )}
                            </Nav>
                        </Accordion.Body>
                    </Accordion.Item>
                )}
                {permissions.length > 0 && ( permissions.includes(PERMISSIONS.COMPLAINT_REOPEN_REASON.VIEW) || permissions.includes(PERMISSIONS.COMPLAINT_CLOSE_REASON.VIEW)
                    || permissions.includes(PERMISSIONS.FUNCTIONAL_AREAS.VIEW) || permissions.includes(PERMISSIONS.SERVICES.VIEW) || permissions.includes(PERMISSIONS.CAMPAIGN_CLOSED_REASON.VIEW)
                    || permissions.includes(PERMISSIONS.IMPROVEMENT_PLANS.VIEW) || permissions.includes(PERMISSIONS.REPORT_DEFINITIONS.VIEW) ) && (
                    <Accordion.Item eventKey="5">
                        <Accordion.Header> {t("menu:admin.accordeonDictionary")}</Accordion.Header>
                        <Accordion.Body style={{ maxHeight: "250px", overflowY: "auto" }}>
                            <Nav className="flex-column">
                                {permissions.length > 0 && permissions.includes(PERMISSIONS.COMPLAINT_CLOSE_REASON.VIEW) && (
                                    <Nav.Link onClick={() => navigateWithGuard("/admin/alertDeleteReason")}>
                                        {t("menu:admin.reasonDeleteAlert")}
                                    </Nav.Link>
                                )}
                            </Nav>
                            <Nav className="flex-column">
                                {permissions.length > 0 && permissions.includes(PERMISSIONS.FUNCTIONAL_AREAS.VIEW) && (

                                    <Nav.Link onClick={() => navigateWithGuard("/admin/functionalAreas")}>
                                        {t("menu:admin.functionalAreas")}
                                    </Nav.Link>
                                )}
                            </Nav>
                            <Nav className="flex-column">
                                {permissions.length > 0 && permissions.includes(PERMISSIONS.CAMPAIGN_CLOSED_REASON.VIEW) && (
                                    <Nav.Link onClick={() => navigateWithGuard("/admin/campaignClosedReason")}>
                                        {t("menu:admin.campaignClosedReason")}
                                    </Nav.Link>
                                )}
                            </Nav>
                            <Nav className="flex-column">
                                {permissions.length > 0 && permissions.includes(PERMISSIONS.COMPLAINT_CLOSE_REASON.VIEW) && (
                                    <Nav.Link onClick={() => navigateWithGuard("/admin/claimProfessionalType")}>
                                        {t("menu:admin.claimProfessionalType")}
                                    </Nav.Link>
                                )}
                            </Nav>
                            <Nav className="flex-column">
                                {permissions.length > 0 && permissions.includes(PERMISSIONS.DEMAND_IN_FORMAT.VIEW) && (
                                    <Nav.Link onClick={() => navigateWithGuard("/admin/demandInFormat")}>
                                        {t("menu:admin.demandInFormat")}
                                    </Nav.Link>
                                )}
                            </Nav>
                            <Nav className="flex-column">
                                {permissions.length > 0 && permissions.includes(PERMISSIONS.DEMAND_OUT_FORMAT.VIEW) && (
                                    <Nav.Link onClick={() => navigateWithGuard("/admin/demandOutFormat")}>
                                        {t("menu:admin.demandOutFormat")}
                                    </Nav.Link>
                                )}
                            </Nav>
                            <Nav className="flex-column">
                                {permissions.length > 0 && permissions.includes(PERMISSIONS.DEMAND_DERIVATION.VIEW) && (
                                    <Nav.Link onClick={() => navigateWithGuard("/admin/demandDerivation")}>
                                        {t("menu:admin.demandDerivation")}
                                    </Nav.Link>
                                )}
                            </Nav>
                            <Nav className="flex-column">
                                {permissions.length > 0 && permissions.includes(PERMISSIONS.DEMAND_CANCEL_REASON.VIEW) && (

                                    <Nav.Link onClick={() => navigateWithGuard("/admin/claimCancelReason")}>
                                        {t("menu:admin.reasonCancelClaim")}
                                    </Nav.Link>
                                )}
                            </Nav>
                            <Nav className="flex-column">
                                {permissions.length > 0 && permissions.includes(PERMISSIONS.COMPLAINT_CLOSE_REASON.VIEW) && (
                                    <Nav.Link onClick={() => navigateWithGuard("/admin/claimDeleteReason")}>
                                        {t("menu:admin.reasonDeleteClaim")}
                                    </Nav.Link>
                                )}
                            </Nav>
                            <Nav className="flex-column">
                                {permissions.length > 0 && permissions.includes(PERMISSIONS.COMPLAINT_CLOSE_REASON.VIEW) && (
                                    <Nav.Link onClick={() => navigateWithGuard("/admin/claimOrigin")}>
                                        {t("menu:admin.claimOrigin")}
                                    </Nav.Link>
                                )}
                            </Nav>
                            <Nav className="flex-column">
                                {permissions.length > 0 && permissions.includes(PERMISSIONS.CLAIM_PERSONAL_RELATIONSHIP.VIEW) && (
                                    <Nav.Link onClick={() => navigateWithGuard("/admin/claimPersonalRelationship")}>
                                        {t("menu:admin.claimPersonalRelationship")}
                                    </Nav.Link>
                                )}
                            </Nav>
                            <Nav className="flex-column">
                                {permissions.length > 0 && permissions.includes(PERMISSIONS.COMPLAINT_REOPEN_REASON.VIEW) && (
                                    <Nav.Link onClick={() => navigateWithGuard("/admin/claimReopenReason")}>
                                        {t("menu:admin.reasonReopenClaim")}
                                    </Nav.Link>
                                )}
                            </Nav>
                            <Nav className="flex-column">
                                {permissions.length > 0 && permissions.includes(PERMISSIONS.CLAIM_REQUEST_TYPE.VIEW) && (
                                    <Nav.Link onClick={() => navigateWithGuard("/admin/claimRequestTypes")}>
                                        {t("menu:admin.claimRequestType")}
                                    </Nav.Link>
                                )}
                            </Nav>
                            <Nav className="flex-column">
                                {permissions.length > 0 && permissions.includes(PERMISSIONS.FOLLOWUP_DEMAND.VIEW) && (
                                    <Nav.Link onClick={() => navigateWithGuard("/admin/claimFollowUpType")}>
                                        {t("menu:admin.claimFollowUpType")}
                                    </Nav.Link>
                                )}
                            </Nav>
                            <Nav className="flex-column">
                                {permissions.length > 0 && permissions.includes(PERMISSIONS.COMPLAINT_CLOSE_REASON.VIEW) && (
                                    <Nav.Link onClick={() => navigateWithGuard("/admin/surveyClosedReason")}>
                                        {t("menu:admin.reasonClosedSurvey")}
                                    </Nav.Link>
                                )}
                            </Nav>
                            <Nav className="flex-column">
                                {permissions.length > 0 && permissions.includes(PERMISSIONS.EVENTS.VIEW) && (
                                    <Nav.Link onClick={() => navigateWithGuard("/admin/event")}>
                                        {t("menu:admin.accordeonEventAction1")}
                                    </Nav.Link>
                                )}
                            </Nav>
                            <Nav className="flex-column">
                                {permissions.length > 0 && permissions.includes(PERMISSIONS.IMPROVEMENT_PLAN_DELETE_REASON.VIEW) && (
                                    <Nav.Link onClick={() => navigateWithGuard("/admin/improvementPlanDeleteReasons")}>
                                        {t("menu:admin.improvementPlanDeleteReason")}
                                    </Nav.Link>
                                )}
                            </Nav>
                            <Nav className="flex-column">
                                {permissions.length > 0 && permissions.includes(PERMISSIONS.IMPROVEMENT_PLAN_FINALIZE_REASON.VIEW) && (

                                    <Nav.Link onClick={() => navigateWithGuard("/admin/improvementPlanFinalizeReasons")}>
                                        {t("menu:admin.improvementPlanFinalizeReason")}
                                    </Nav.Link>
                                )}
                            </Nav>
                            <Nav className="flex-column">
                                {permissions.length > 0 && permissions.includes(PERMISSIONS.IMPROVEMENT_PLAN_ORIGIN.VIEW) && (
                                    <Nav.Link onClick={() => navigateWithGuard("/admin/improvementPlanOrigin")}>
                                        {t("menu:admin.improvementPlanOrigin")}
                                    </Nav.Link>
                                )}
                            </Nav>
                            <Nav className="flex-column">
                                {permissions.length > 0 && permissions.includes(PERMISSIONS.IMPROVEMENT_PLAN_TYPE.VIEW) && (
                                    <Nav.Link onClick={() => navigateWithGuard("/admin/improvementPlanType")}>
                                        {t("menu:admin.improvementPlanType")}
                                    </Nav.Link>
                                )}
                            </Nav>
                     
                            <Nav className="flex-column">
                                {permissions.length > 0 && permissions.includes(PERMISSIONS.USER_COMMUNICATION_TYPE.VIEW) && (
                                    <Nav.Link onClick={() => navigateWithGuard("/admin/userCommunicationTypes")}>
                                        {t("userCommunicationType:title")}
                                    </Nav.Link>
                                )}
                            </Nav>
                            
                            <Nav className="flex-column">
                                {permissions.length > 0 && permissions.includes(PERMISSIONS.REPORT_DEFINITIONS.VIEW) &&(
                                    <Nav.Link onClick={() => navigateWithGuard("/admin/report-definitions")}>
                                        {t("menu:admin.reports")}
                                    </Nav.Link>
                                )}
                            </Nav>
                            <Nav className="flex-column">
                                {permissions.length > 0 && permissions.includes(PERMISSIONS.SERVICES.VIEW) && (
                                    <Nav.Link onClick={() => navigateWithGuard("/admin/serviceIndicators")}>
                                        {t("menu:admin.serviceIndicators")}
                                    </Nav.Link>
                                )}
                            </Nav>
                        </Accordion.Body>
                    </Accordion.Item>
                    )}
                {permissions.length > 0 && permissions.includes(PERMISSIONS.AUDIT.VIEW) && (
                    <Accordion.Item eventKey="6">
                        <Accordion.Header>{t("menu:admin.Audit")}</Accordion.Header>
                        <Accordion.Body>
                            <Nav className="flex-column">
                                {permissions.length > 0 && permissions.includes(PERMISSIONS.AUDIT.VIEW) && (
                                    <Nav.Link onClick={() => navigateWithGuard("/admin/auditLogs")}>
                                        {t("menu:admin.Audit")}
                                    </Nav.Link>
                                )}
                            </Nav>
                        </Accordion.Body>
                    </Accordion.Item>
                )}
            </Accordion>
        </div>
    );
}
